export default __webpack_public_path__ + "static/media/challenge-disabled.5be15e9d.svg";